import { c as _c } from "react/compiler-runtime";
import { IcoMinusSmall16, IcoPlusSmall16 } from '@onefootprint/icons';
type CategoryToggleProps = {
  categoryName: string;
  onClick: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  isActive: boolean;
  tabIndex?: number;
};
const CategoryToggle = t0 => {
  const $ = _c(12);
  const {
    categoryName,
    onClick,
    onKeyDown,
    isActive,
    tabIndex: t1
  } = t0;
  const tabIndex = t1 === undefined ? 0 : t1;
  const t2 = `${categoryName} toggle`;
  let t3;
  if ($[0] !== isActive) {
    t3 = isActive ? <IcoMinusSmall16 color="secondary" /> : <IcoPlusSmall16 color="secondary" />;
    $[0] = isActive;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== categoryName) {
    t4 = <div className="text-label-2 text-secondary">{categoryName}</div>;
    $[2] = categoryName;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isActive || $[5] !== onClick || $[6] !== onKeyDown || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== tabIndex) {
    t5 = <button type="button" className="flex items-center gap-2 p-1 transition-all rounded duration-50 group hover:bg-hover" onClick={onClick} onKeyDown={onKeyDown} tabIndex={tabIndex} aria-expanded={isActive} aria-label={t2}>{t3}{t4}</button>;
    $[4] = isActive;
    $[5] = onClick;
    $[6] = onKeyDown;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = tabIndex;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default CategoryToggle;